import React from 'react';
import { Ban, Flag, Heart } from 'lucide-react';

export default function LikesView({
  likedBy, profile, user,
  onLikeBack, onBlockUser, onOpenReportModal,
}) {
  return (
          <div className="fade-in" style={{ padding: '20px' }}>
            <h3 style={{
              fontSize: '24px',
              fontWeight: 700,
              marginBottom: '8px',
              color: '#2c3e50'
            }}>
              People who like you
            </h3>
            <p style={{
              color: '#7f8c8d',
              marginBottom: '24px',
              fontSize: '14px'
            }}>
              ✨ No paywall! See everyone who's interested
            </p>
            
            {likedBy.length === 0 ? (
              <div style={{
                textAlign: 'center',
                padding: '60px 20px',
                color: '#95a5a6'
              }}>
                <Heart size={48} style={{ marginBottom: '16px', opacity: 0.3 }} />
                <p>No new likes yet. Keep swiping!</p>
              </div>
            ) : (
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)',
                gap: '16px'
              }}>
                {likedBy.map(item => {
                  const profile = item.user || item;
                  const profileKey = profile.userId || profile._id || item.id;
                  return (
                  <div key={profileKey} style={{
                    borderRadius: '16px',
                    overflow: 'hidden',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                    position: 'relative',
                    cursor: 'pointer'
                  }}>
                    <img
                      src={profile.photos?.[0]?.url || 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=800&q=80'}
                      alt={profile.firstName}
                      style={{
                        width: '100%',
                        height: '200px',
                        objectFit: 'cover'
                      }}
                    />
                    <div style={{
                      padding: '12px',
                      background: 'white'
                    }}>
                      <h4 style={{
                        margin: '0 0 4px 0',
                        fontSize: '16px',
                        fontWeight: 600
                      }}>
                        {profile.firstName}, {profile.age}
                      </h4>
                      <p style={{
                        margin: 0,
                        fontSize: '12px',
                        color: '#7f8c8d'
                      }}>
                        {profile.distance || 'Nearby'}
                      </p>
                      <div style={{
                        display: 'flex',
                        gap: '8px',
                        marginTop: '12px'
                      }}>
                        <button
                          onClick={() => onLikeBack(item)}
                          style={{
                            flex: 1,
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            color: 'white',
                            border: 'none',
                            padding: '10px',
                            borderRadius: '10px',
                            cursor: 'pointer',
                            fontWeight: 600,
                            fontSize: '14px'
                          }}
                        >
                          Like Back ❤️
                        </button>
                        <button
                          onClick={() => onBlockUser(profile.userId || profile._id, 'likes')}
                          title="Block user"
                          style={{
                            width: '40px',
                            background: '#e74c3c',
                            color: 'white',
                            border: 'none',
                            padding: '10px',
                            borderRadius: '10px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          <Ban size={18} />
                        </button>
                        <button
                          onClick={() => onOpenReportModal(profile.userId || profile._id, profile.firstName, 'likes')}
                          title="Report user"
                          style={{
                            width: '40px',
                            background: '#e67e22',
                            color: 'white',
                            border: 'none',
                            padding: '10px',
                            borderRadius: '10px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          <Flag size={18} />
                        </button>
                      </div>
                    </div>
                  </div>
                  );
                })}
              </div>
            )}
          </div>
  );
}
